__turbopack_context__.v({
  "bottomContainer": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__bottomContainer",
  "businessInfo": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__businessInfo",
  "businessNumber": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__businessNumber",
  "container": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__container",
  "infoItemContainer": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__infoItemContainer",
  "legalName": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__legalName",
  "mapView": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__mapView",
  "metaContainer": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__metaContainer",
  "orderFormat": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__orderFormat",
  "orderFormats": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__orderFormats",
  "outletName": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__outletName",
  "w30": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__w30",
  "w40": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__w40",
  "w50": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__w50",
  "w60": "OutletDetailsModalSkeleton-module-scss-module__MFlthq__w60",
});
